import React, { createContext, useContext, useState, useCallback } from "react";

export const translations = {
  pt: {
    nav: {
      home: "Home",
      services: "Serviços",
      about: "Sobre",
      clients: "Clientes",
      contact: "Contato",
      clientArea: "Área do Cliente",
      consult: "Solicite uma consultoria",
    },
    hero: {
      badge: "Infraestrutura de TI · Segurança · Cloud",
      title1: "Segurança para sua empresa.",
      title2: "Desempenho que impulsiona",
      title3: "resultados.",
      subtitle:
        "Construímos a base tecnológica que protege, acelera e sustenta o crescimento da sua empresa no ambiente digital.",
      ctaPrimary: "Solicite uma consultoria gratuita",
      ctaSecondary: "Conheça nossas soluções",
      stat1: "Desde 2019",
      stat1label: "construindo soluções em TI",
      stat2: "100%",
      stat2label: "empresas atendidas",
      stat3: "24/7",
      stat3label: "monitoramento proativo",
      endToEnd: "Ponta a ponta",
      endToEndLabel: "infraestrutura, segurança e desenvolvimento",
      whatsappMsg: "Olá! Gostaria de solicitar uma consultoria gratuita com a Waltech.",
    },
    services: {
      overline: "Nossas soluções",
      title: "Tecnologia que sustenta o seu negócio",
      subtitle:
        "Da infraestrutura ao software: a Waltech atua de ponta a ponta para proteger, otimizar, escalar e desenvolver as soluções digitais da sua empresa.",
      tagline: "Infraestrutura + Segurança + Suporte + Desenvolvimento",
      more: "Saiba mais",
      whatsappMsg: (name) =>
        `Olá! Tenho interesse no serviço de ${name} da Waltech.`,
      development: {
        title: "Desenvolvimento de Sistemas e Sites",
        overline: "Nova solução",
        desc: "Desenvolvemos sistemas e sites sob medida para as necessidades de cada empresa, criando soluções digitais modernas, seguras e eficientes.",
        cta: "Quero desenvolver meu projeto",
        whatsappMsg: "Olá! Quero desenvolver um projeto de sistema ou site com a Waltech.",
        tags: [
          "Sistemas personalizados",
          "Sistemas web e aplicações",
          "Sites institucionais",
          "Landing pages",
          "Sites responsivos",
          "Portais e plataformas",
          "Integrações entre sistemas",
          "Automação de processos",
          "Modernização de sistemas",
          "Manutenção e evolução",
        ],
      },
      items: {
        support: {
          title: "Suporte Técnico Especializado",
          short: "Suporte remoto e presencial para manter sua operação sempre em funcionamento.",
          long:
            "Oferecemos suporte técnico remoto e presencial para garantir o funcionamento contínuo da infraestrutura de TI da sua empresa. Atuamos na identificação e resolução de problemas relacionados a e-mails, impressoras, redes, sistemas operacionais, softwares e equipamentos em geral, minimizando impactos no dia a dia da operação. Realizamos atendimentos ágeis, com manutenção preventiva e corretiva, gestão de usuários e acessos, além de atualizações regulares de sistemas e aplicações.",
          tags: ["Suporte remoto", "Suporte presencial", "Redes", "Manutenção preventiva", "Gestão de acessos"],
        },
        security: {
          title: "Segurança de Dados",
          short: "Proteção contra acessos não autorizados, perdas e ataques cibernéticos.",
          long:
            "Protegemos as informações da sua empresa contra acessos não autorizados, perdas e ataques cibernéticos. Atuamos de forma preventiva com políticas, ferramentas e tecnologias que garantem a confidencialidade, integridade e disponibilidade dos dados, em ambientes locais, em nuvem ou híbridos. Nossas soluções incluem controle de acesso, firewalls, criptografia, backups seguros e monitoramento contínuo — sempre com foco em proteção, continuidade e conformidade com normas como a LGPD.",
          tags: ["Firewalls", "Criptografia", "Controle de acesso", "Monitoramento", "LGPD"],
        },
        infra: {
          title: "Gerenciamento de Infraestrutura",
          short: "Desempenho, segurança e disponibilidade dos seus servidores on-premise ou em nuvem.",
          long:
            "Garantimos o desempenho, a segurança e a disponibilidade dos seus servidores, seja em ambiente local (on-premise), virtualizado ou em nuvem. Cuidamos de toda a infraestrutura, desde a instalação e configuração até o monitoramento contínuo, atualizações, backups e resposta a incidentes. Trabalhamos com servidores Windows, Linux e ambientes híbridos, sempre com foco em estabilidade, performance e proteção dos dados.",
          tags: ["Servidores", "Virtualização", "Cloud", "Windows & Linux", "Resposta a incidentes"],
        },
        backup: {
          title: "Backup",
          short: "Backup local e em nuvem com recuperação garantida, mesmo em incidentes graves.",
          long:
            "Proteja os dados da sua empresa contra perdas, falhas e ataques com soluções completas de backup local e em nuvem. Oferecemos estratégias personalizadas para garantir que suas informações estejam sempre seguras, acessíveis e prontas para recuperação, mesmo em casos de incidentes graves como falhas de hardware, exclusões acidentais ou ataques de ransomware.",
          tags: ["Backup local", "Backup em nuvem", "Anti-ransomware", "Recuperação de dados", "Continuidade"],
        },
        licensing: {
          title: "Licenciamento",
          short: "Consultoria, aquisição e gestão de licenças dos principais softwares do mercado.",
          long:
            "Garanta a legalidade, segurança e eficiência dos sistemas da sua empresa com o licenciamento adequado de softwares. Oferecemos consultoria, aquisição e gestão de licenças para os principais softwares do mercado, como antivírus corporativos, Microsoft Office 365, Windows, ferramentas de produtividade e colaboração, soluções de segurança e muito mais.",
          tags: ["Office 365", "Windows", "Antivírus corporativo", "Produtividade", "Gestão de licenças"],
        },
        projects: {
          title: "Projetos",
          short: "Projetos completos de redes e infraestrutura, prontos para crescer com o seu negócio.",
          long:
            "Desenvolvemos e executamos projetos completos de redes e infraestrutura de TI, com foco em desempenho, organização, segurança e escalabilidade. Nosso objetivo é garantir que o ambiente tecnológico da sua empresa funcione com eficiência e esteja preparado para crescer junto com o seu negócio. Oferecemos soluções que vão desde a estrutura física da rede até a migração e modernização de sistemas, sempre com planejamento técnico, equipe qualificada e entrega padronizada.",
          tags: ["Redes", "Migração", "Modernização", "Escalabilidade", "Padronização"],
        },
      },
    },
    differentiator: {
      overline: "Nosso compromisso",
      main: "Sem multa contratual.",
      quote: "Aqui, você não fica preso por obrigação, mas permanece por confiança.",
      secondary:
        "Nossa parceria é baseada em resultado, transparência e compromisso real com o cliente. Não cobramos multa de cancelamento porque sabemos que a qualidade do nosso serviço fala por si.",
    },
    about: {
      overline: "Sobre a Waltech",
      title: "Uma parceria sólida em gestão e infraestrutura de TI",
      p1: "Desde janeiro de 2019, a Waltech vem oferecendo soluções completas e personalizadas em infraestrutura de TI e segurança de rede para empresas de todo o Brasil. Fundada por Jeferson Davi, nosso representante legal, a Waltech nasceu da paixão por tecnologia aliada ao compromisso de entregar resultados sólidos, confiáveis e alinhados às necessidades reais dos nossos clientes.",
      p2: "Com uma equipe qualificada e focada no profissionalismo, atuamos com agilidade e excelência para garantir que a infraestrutura tecnológica das empresas esteja sempre segura, estável e preparada para o crescimento. Entendemos que, em um mundo cada vez mais digital, a continuidade operacional e a proteção dos dados são essenciais para o sucesso dos negócios — por isso, oferecemos suporte técnico especializado, monitoramento proativo e soluções que unem inovação e eficiência.",
      p3: "Nosso atendimento é pautado na experiência acumulada e na prontidão para resolver os desafios de TI, sempre buscando antecipar problemas e reduzir riscos. Na Waltech, acreditamos que a confiança é construída com transparência, compromisso e entrega consistente de valor.",
      founderName: "Jeferson Davi",
      founderRole: "CEO",
      founderTag: "Fundador da Waltech",
      values: ["Experiência", "Profissionalismo", "Agilidade", "Excelência", "Inovação", "Eficiência"],
    },
    clients: {
      overline: "Confiança comprovada",
      title: "Empresas que confiam na Waltech",
      subtitle: "Negócios que contam com a nossa infraestrutura todos os dias.",
    },
    pillars: {
      overline: "Por que Waltech",
      title: "Seu negócio não pode parar.",
      subtitle: "Cinco pilares que sustentam a continuidade da sua operação.",
      items: [
        { key: "SEGURANÇA", desc: "Proteção de dados e defesa contra ameaças cibernéticas." },
        { key: "DISPONIBILIDADE", desc: "Ambientes estáveis e sempre acessíveis quando você precisa." },
        { key: "PERFORMANCE", desc: "Infraestrutura otimizada para máximo desempenho." },
        { key: "CONTINUIDADE", desc: "Backups e planos que mantêm sua empresa funcionando." },
        { key: "SUPORTE", desc: "Atendimento ágil, próximo e especializado." },
      ],
    },
    cta: {
      title: "Pronto para transformar a infraestrutura de TI da sua empresa?",
      text: "Conte com a Waltech para proteger seu ambiente digital, reduzir riscos e manter sua empresa funcionando.",
      button: "Solicite uma consultoria gratuita",
      whatsappMsg: "Olá! Quero transformar a infraestrutura de TI da minha empresa. Podemos conversar?",
    },
    contact: {
      overline: "Fale com a gente",
      title: "Vamos conversar sobre a sua TI",
      subtitle: "Preencha o formulário e retornaremos o mais breve possível. Ao enviar, abriremos uma conversa no WhatsApp com os seus dados.",
      firstName: "Nome",
      lastName: "Sobrenome",
      phone: "Telefone",
      email: "E-mail",
      company: "Nome da empresa",
      companySize: "Tamanho da empresa",
      companySizePlaceholder: "Quantidade de colaboradores",
      message: "Sua mensagem",
      send: "Enviar mensagem",
      sending: "Enviando...",
      sizes: ["1 à 10", "11 à 50", "51 à 100", "Mais de 100"],
      infoTitle: "Informações de contato",
      addressTitle: "Nosso endereço",
      success: "Mensagem enviada com sucesso! Abrindo o WhatsApp...",
      error: "Não foi possível enviar. Tente novamente.",
      errors: {
        firstName: "Informe seu nome",
        phone: "Informe um telefone válido",
        email: "Informe um e-mail válido",
        company: "Informe o nome da empresa",
        companySize: "Selecione o tamanho",
        message: "Escreva uma mensagem",
      },
    },
    footer: {
      desc: "Infraestrutura de TI, suporte técnico e segurança de dados para empresas que não podem parar.",
      navTitle: "Navegação",
      contactTitle: "Contato",
      rights: "Todos os direitos reservados.",
    },
    whatsapp: {
      float: "Falar no WhatsApp",
      floatMsg: "Olá! Gostaria de mais informações sobre os serviços da Waltech.",
    },
  },

  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      clients: "Clients",
      contact: "Contact",
      clientArea: "Client Area",
      consult: "Request a consultation",
    },
    hero: {
      badge: "IT Infrastructure · Security · Cloud",
      title1: "Security for your company.",
      title2: "Performance that drives",
      title3: "results.",
      subtitle:
        "We build the technological foundation that protects, accelerates and sustains your company's growth in the digital environment.",
      ctaPrimary: "Request a free consultation",
      ctaSecondary: "Explore our solutions",
      stat1: "Since 2019",
      stat1label: "building IT solutions",
      stat2: "100%",
      stat2label: "business focused",
      stat3: "24/7",
      stat3label: "proactive monitoring",
      endToEnd: "End to end",
      endToEndLabel: "infrastructure, security & development",
      whatsappMsg: "Hello! I'd like to request a free consultation with Waltech.",
    },
    services: {
      overline: "Our solutions",
      title: "Technology that sustains your business",
      subtitle:
        "From infrastructure to software: Waltech works end to end to protect, optimize, scale and build your company's digital solutions.",
      tagline: "Infrastructure + Security + Support + Development",
      more: "Learn more",
      whatsappMsg: (name) => `Hello! I'm interested in Waltech's ${name} service.`,
      development: {
        title: "Systems & Websites Development",
        overline: "New solution",
        desc: "We build custom systems and websites tailored to each company's needs, creating modern, secure and efficient digital solutions.",
        cta: "I want to build my project",
        whatsappMsg: "Hello! I want to build a system or website project with Waltech.",
        tags: [
          "Custom systems",
          "Web systems & apps",
          "Institutional websites",
          "Landing pages",
          "Responsive websites",
          "Portals & platforms",
          "System integrations",
          "Process automation",
          "System modernization",
          "Maintenance & evolution",
        ],
      },
      items: {
        support: {
          title: "Specialized Technical Support",
          short: "Remote and on-site support to keep your operation always running.",
          long:
            "We offer remote and on-site technical support to ensure the continuous operation of your company's IT infrastructure. We identify and resolve issues related to email, printers, networks, operating systems, software and equipment in general, minimizing impacts on day-to-day operations. We deliver agile service, with preventive and corrective maintenance, user and access management, plus regular system and application updates.",
          tags: ["Remote support", "On-site support", "Networks", "Preventive maintenance", "Access management"],
        },
        security: {
          title: "Data Security",
          short: "Protection against unauthorized access, data loss and cyber attacks.",
          long:
            "We protect your company's information against unauthorized access, loss and cyber attacks. We act preventively with policies, tools and technologies that guarantee the confidentiality, integrity and availability of data, in local, cloud or hybrid environments. Our solutions include access control, firewalls, encryption, secure backups and continuous monitoring — always focused on protection, continuity and compliance with regulations such as LGPD.",
          tags: ["Firewalls", "Encryption", "Access control", "Monitoring", "LGPD"],
        },
        infra: {
          title: "Infrastructure Management",
          short: "Performance, security and availability for your on-premise or cloud servers.",
          long:
            "We guarantee the performance, security and availability of your servers, whether on-premise, virtualized or in the cloud. We take care of the entire infrastructure, from installation and configuration to continuous monitoring, updates, backups and incident response. We work with Windows, Linux and hybrid environments, always focused on stability, performance and data protection.",
          tags: ["Servers", "Virtualization", "Cloud", "Windows & Linux", "Incident response"],
        },
        backup: {
          title: "Backup",
          short: "Local and cloud backup with guaranteed recovery, even in severe incidents.",
          long:
            "Protect your company's data against loss, failures and attacks with complete local and cloud backup solutions. We offer personalized strategies to ensure your information is always secure, accessible and ready for recovery, even in cases of severe incidents such as hardware failures, accidental deletions or ransomware attacks.",
          tags: ["Local backup", "Cloud backup", "Anti-ransomware", "Data recovery", "Continuity"],
        },
        licensing: {
          title: "Licensing",
          short: "Consulting, acquisition and management of licenses for the market's leading software.",
          long:
            "Ensure the legality, security and efficiency of your company's systems with proper software licensing. We offer consulting, acquisition and management of licenses for the market's leading software, such as corporate antivirus, Microsoft Office 365, Windows, productivity and collaboration tools, security solutions and much more.",
          tags: ["Office 365", "Windows", "Corporate antivirus", "Productivity", "License management"],
        },
        projects: {
          title: "Projects",
          short: "Complete network and infrastructure projects, ready to grow with your business.",
          long:
            "We develop and execute complete IT network and infrastructure projects, focused on performance, organization, security and scalability. Our goal is to ensure your company's technological environment runs efficiently and is prepared to grow alongside your business. We offer solutions ranging from the physical network structure to the migration and modernization of systems, always with technical planning, a qualified team and standardized delivery.",
          tags: ["Networks", "Migration", "Modernization", "Scalability", "Standardization"],
        },
      },
    },
    differentiator: {
      overline: "Our commitment",
      main: "No contract penalties.",
      quote: "Here, you don't stay out of obligation — you stay out of trust.",
      secondary:
        "Our partnership is based on results, transparency and a real commitment to the client. We don't charge cancellation fees because we know the quality of our service speaks for itself.",
    },
    about: {
      overline: "About Waltech",
      title: "A solid partnership in IT management and infrastructure",
      p1: "Since January 2019, Waltech has been offering complete and personalized IT infrastructure and network security solutions for companies throughout Brazil. Founded by Jeferson Davi, our legal representative, Waltech was born from a passion for technology combined with a commitment to deliver solid, reliable results aligned with our clients' real needs.",
      p2: "With a qualified team focused on professionalism, we work with agility and excellence to ensure that companies' technological infrastructure is always secure, stable and prepared for growth. We understand that, in an increasingly digital world, operational continuity and data protection are essential for business success — which is why we offer specialized technical support, proactive monitoring and solutions that combine innovation and efficiency.",
      p3: "Our service is grounded in accumulated experience and readiness to solve IT challenges, always seeking to anticipate problems and reduce risks. At Waltech, we believe trust is built with transparency, commitment and consistent delivery of value.",
      founderName: "Jeferson Davi",
      founderRole: "CEO",
      founderTag: "Founder of Waltech",
      values: ["Experience", "Professionalism", "Agility", "Excellence", "Innovation", "Efficiency"],
    },
    clients: {
      overline: "Proven trust",
      title: "Companies that trust Waltech",
      subtitle: "Businesses that rely on our infrastructure every day.",
    },
    pillars: {
      overline: "Why Waltech",
      title: "Your business can't stop.",
      subtitle: "Five pillars that sustain the continuity of your operation.",
      items: [
        { key: "SECURITY", desc: "Data protection and defense against cyber threats." },
        { key: "AVAILABILITY", desc: "Stable environments, always accessible when you need them." },
        { key: "PERFORMANCE", desc: "Optimized infrastructure for maximum performance." },
        { key: "CONTINUITY", desc: "Backups and plans that keep your company running." },
        { key: "SUPPORT", desc: "Agile, close and specialized service." },
      ],
    },
    cta: {
      title: "Ready to transform your company's IT infrastructure?",
      text: "Count on Waltech to protect your digital environment, reduce risks and keep your company running.",
      button: "Request a free consultation",
      whatsappMsg: "Hello! I want to transform my company's IT infrastructure. Can we talk?",
    },
    contact: {
      overline: "Get in touch",
      title: "Let's talk about your IT",
      subtitle: "Fill in the form and we'll get back to you as soon as possible. On submit, we'll open a WhatsApp chat with your details.",
      firstName: "First name",
      lastName: "Last name",
      phone: "Phone",
      email: "Email",
      company: "Company name",
      companySize: "Company size",
      companySizePlaceholder: "Number of employees",
      message: "Your message",
      send: "Send message",
      sending: "Sending...",
      sizes: ["1 to 10", "11 to 50", "51 to 100", "More than 100"],
      infoTitle: "Contact information",
      addressTitle: "Our address",
      success: "Message sent successfully! Opening WhatsApp...",
      error: "Could not send. Please try again.",
      errors: {
        firstName: "Enter your name",
        phone: "Enter a valid phone",
        email: "Enter a valid email",
        company: "Enter the company name",
        companySize: "Select the size",
        message: "Write a message",
      },
    },
    footer: {
      desc: "IT infrastructure, technical support and data security for companies that can't stop.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      rights: "All rights reserved.",
    },
    whatsapp: {
      float: "Chat on WhatsApp",
      floatMsg: "Hello! I'd like more information about Waltech's services.",
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("pt");
  const toggle = useCallback(() => setLang((l) => (l === "pt" ? "en" : "pt")), []);
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
